import moment from 'moment';
import { createOrUpdateEvent } from '../../../services/lwadmin/livewire-events/events-service';

export default class LivewireEvent {
  constructor(source) {
    Object.assign(this, source || {
      id: null,
      name: '',
      slug: '',
      starts_at: null,
      eventbrite_id: '',
      rollover_eventbrite_id: '',
      city: '',
      hidden: false,
      include_digital_pass: true,
    });

    this.starts_at = this.starts_at ? moment(this.starts_at) : null;
    this.name = this.name || '';
    this.slug = this.slug || '';
    this.eventbrite_id = this.eventbrite_id || '';
    this.rollover_eventbrite_id = this.rollover_eventbrite_id || '';
    this.city = this.city || '';
    this.starts_at_time = this.starts_at ? this.starts_at.format('HH:mm') : '';
  }

  toDto() {
    const startsAtTimeMoment = moment(`1900-01-01T${this.starts_at_time}`);

    this.starts_at.hour(startsAtTimeMoment.hour());
    this.starts_at.minute(startsAtTimeMoment.minute());

    return {
      id: this.id,
      name: this.name,
      slug: this.slug,
      starts_at: this.starts_at ? this.starts_at.toDate() : null,
      eventbrite_id: this.eventbrite_id,
      rollover_eventbrite_id: this.rollover_eventbrite_id,
      city: this.city,
      hidden: this.hidden,
      include_digital_pass: this.include_digital_pass,
    };
  }

  show() {
    this.hidden = false;

    return this.save();
  }

  hide() {
    this.hidden = true;

    return this.save();
  }

  save() {
    return createOrUpdateEvent(this.toDto());
  }
}
